import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	copyLink: {
		id: 'servicedesk-reports-common.table.issue-table.body.field-renderer.kb-link.footer.copy-link',
		defaultMessage: 'Copy link',
		description: 'Text for copy link button.',
	},
	editPage: {
		id: 'servicedesk-reports-common.table.issue-table.body.field-renderer.kb-link.footer.edit-page',
		defaultMessage: 'Edit page',
		description: 'Text for the edit page button.',
	},
	cancel: {
		id: 'servicedesk-reports-common.table.issue-table.body.field-renderer.kb-link.footer.cancel',
		defaultMessage: 'Cancel',
		description: 'Text for the cancel button.',
	},
});
